export enum ProviderEnum {
    NAP69 = 'nap69',
    WPAY = 'wpay',
    NCCTOPUP = 'ncctopup',
    NAP69_BTKC = 'nap69_btkc',
    ECO = 'eco',
    TRUONGHAI = 'truonghai',
    THNT = 'thnt',
    UNIEPAY = 'uniepay',
    WPAY2 = 'wpay2',
}

export const ProviderName: Record<ProviderEnum, string> = {
    [ProviderEnum.NAP69]: "TH Thẻ",
    [ProviderEnum.WPAY]: "Linh San - Wpay",
    [ProviderEnum.NCCTOPUP]: "NCC Topup",
    [ProviderEnum.NAP69_BTKC]: "Deleting...",
    [ProviderEnum.ECO]: "Eco",
    [ProviderEnum.TRUONGHAI]: "Trường Hải",
    [ProviderEnum.THNT]: "TH NT",
    [ProviderEnum.UNIEPAY]: "Uniepay",
    [ProviderEnum.WPAY2]: "Linh San - Wpay 2",
};